import { IgenomicsAction } from '@ispm/core/interfaces/genomics-action.interface';
import * as immutable from 'immutable';
import { DIAGNOSTIC_ORDER_ACTIONS } from '../constants/diagnostic-order.constants';
import { IDiagnosticOrder } from '../interfaces/diagnostic-order.interface';


export interface IDiagnosticOrderState {
  order: IDiagnosticOrder;
  allOrders: immutable.List<IDiagnosticOrder>;
  allOrdersForTest: immutable.List<IDiagnosticOrder>;
  notes: number;
}

const InitDiagnosticOrderState: IDiagnosticOrderState = {
  order: <IDiagnosticOrder> { },
  allOrders: immutable.List<IDiagnosticOrder>(),
  allOrdersForTest : immutable.List<IDiagnosticOrder>(),
  notes: 0,
};

export function diagnosticOrderReducer(state: IDiagnosticOrderState = InitDiagnosticOrderState,
  action: IgenomicsAction): IDiagnosticOrderState {
  let newState;
  switch (action.type) {
    case DIAGNOSTIC_ORDER_ACTIONS.INIT_DIAGNOSTIC_ORDER_CONFIG:
      newState = Object.assign({ }, state);
      newState.order = { };
      return newState;
    case DIAGNOSTIC_ORDER_ACTIONS.INIT_DIAGNOSTIC_ORDER_STATE:
      return InitDiagnosticOrderState;
    case DIAGNOSTIC_ORDER_ACTIONS.SET_ALL_DIAGNOSTIC_ORDERS:
      newState = Object.assign({ }, state);
      newState.allOrders = new Proxy(immutable.List(action.payload), { });
      return newState;
    case DIAGNOSTIC_ORDER_ACTIONS.SET_DIAGNOSTIC_ORDER_CONFIG:
      newState = Object.assign({ }, state);
      newState.order = Object.assign({ }, action.payload);
      return newState;
    case DIAGNOSTIC_ORDER_ACTIONS.UPDATE_DIAGNOSTIC_ORDER_FIELDS:
      newState = Object.assign({ }, state);
      newState.order = Object.assign(state.order, action.payload);
      return newState;
    case DIAGNOSTIC_ORDER_ACTIONS.SET_NOTES:
      newState = Object.assign({ }, state);
      newState.notes = action.payload;
      return newState;
    case DIAGNOSTIC_ORDER_ACTIONS.SET_NOTES_CONTENT:
      newState = Object.assign({ }, state);
      newState.order.notesContent = action.payload;
      return newState;
    case DIAGNOSTIC_ORDER_ACTIONS.SET_ORDERS_FOR_TEST_ALL_ITEMS:
      newState = Object.assign({ }, state);
      newState.allOrdersForTest = new Proxy(immutable.List(action.payload), { });
      return newState;
    default:
      return state;
  }
}
